module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0